import React, {useMemo, useState} from "react";
import logo from "../../assets/logo2.png";
import styles from "./styles.module.css";
import {Link, useNavigate} from "react-router-dom";
import {hooks} from "../../hooks";

const Navigation = ({user}) => {
	const navigate = useNavigate();
	const posts = hooks.usePost();

	const [search, setSearch] = useState("");
	const [show, setShow] = useState(false);

	const filtered = useMemo(() => {
		if (!search.trim()) return [];

		return posts
			.filter(post => post?.title?.toLowerCase().includes(search.toLowerCase()))
			.slice(0, 6);
	}, [posts, search]);

	const handleChange = e => {
		setSearch(e.target.value);
		setShow(true);
	};

	const handleSuggestionClick = post => {
		setSearch("");
		setShow(false);
		navigate(`/post/${post._id}`, {state: post});
	};

	return (
		<nav className={styles.navigation}>
			<div className={styles.navInner}>
				<Link to="/" className={styles.brand}>
					<img src={logo} alt="LBAN Blog Logo" />
					<span>LBAN BLOG</span>
				</Link>

				<div className={styles.navLinks}>
					<Link to="/microsoft">Microsoft</Link>
					<Link to="/posts">Posts</Link>
				</div>

				<div className={styles.inputContainer}>
					<input
						name="search"
						value={search}
						onChange={handleChange}
						onFocus={() => setShow(true)}
						placeholder="Search posts..."
						autoComplete="off"
					/>

					{show && search && (
						<ul className={styles.autocomplete}>
							{filtered.length > 0 ?
								filtered.map(post => (
									<li
										key={post._id}
										onClick={() => handleSuggestionClick(post)}
									>
										{post.title}
									</li>
								))
							:	<li className={styles.noResult}>No results found</li>}
						</ul>
					)}
				</div>

				{/* Optional auth section */}
				{/* <div className={styles.profile}>
					{user ? (
						<span>Hi, {user.firstname}</span>
					) : (
						<>
							<Link to="/login">Sign In</Link>
							<Link to="/create-account">Create Account</Link>
						</>
					)}
				</div> */}
			</div>
		</nav>
	);
};

export default Navigation;
